<script setup lang="ts">
import { RouterView } from 'vue-router'
</script>

<template>
  <div class="app-container">
    <RouterView name="header" />
    <main class="main-content">
      <RouterView />
    </main>
    <RouterView name="footer" />
  </div>
</template>

<style>
.app-container {
  display: flex;
  flex-direction: column;
}
</style>
